<div id="imageoneReporting" *ngIf="imageoneReporting">
    <imageone-reporting [pageDisplay]="pageDisplay" [pageTitle]="pageTitle">
    </imageone-reporting>
</div>